import React from 'react'

const JoinIcon = () => {
  return (
    <div style={{transform:'translate(5px,9px)'}}>
    <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 256 256"
          style={{ fill: '#000000' }}
        >
          <g fill="#18B200" fillRule="nonzero">
            <g transform="scale(4,4)">
              <path fill="#18B200" d="M42,41c0,2.209-1.791,4-4,4H15c-2.209,0-4-1.791-4-4V7c0-2.209,1.791-4,4-4h23c2.209,0,4,1.791,4,4V41z"></path><path fill="#3F51B5" d="M33 24L21 34 21 14z"></path><path fill="#3F51B5" d="M6 21H23V27H6z"></path>
            </g>
          </g>
        </svg>

    </div>

  )
}

export default JoinIcon